import { render, staticRenderFns } from "./Title_Project.vue?vue&type=template&id=5297f984&scoped=true&"
import script from "./Title_Project.vue?vue&type=script&lang=js&"
export * from "./Title_Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297f984",
  null
  
)

export default component.exports